import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=4bf2a8f3&scoped=true"
import script from "./bind-phone.vue?vue&type=script&lang=js"
export * from "./bind-phone.vue?vue&type=script&lang=js"
import style0 from "./bind-phone.vue?vue&type=style&index=0&id=4bf2a8f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf2a8f3",
  null
  
)

export default component.exports